import { useEffect, useState } from 'react';

export function TextHero({ children, size, color }) {
  const [fontSize, setFontSize] = useState(size || '100px');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) setFontSize('40px');
      else if (width < 768) setFontSize('60px');
      else if (width < 1024) setFontSize('80px');
      else setFontSize(size || '80px');
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [size]);

  return (
    <h1
      style={{
        fontSize: fontSize,
        lineHeight: fontSize,
        opacity: 0.7,
        transform: 'translate(0px, 0px)',
        color: 'transparent',
        WebkitTextStroke: color ? '1px ' + color : '1px white',
        textStroke: color ? '1px ' + color : '1px white',
        fontFamily: '"Montserrat", sans-serif',
        fontWeight: 'bold',
        letterSpacing: '2px',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        textTransform: 'uppercase',
        margin: 0,
        overflow: 'hidden',
        textAlign:"center"
      }}
    >
      {children}
    </h1>
  );
}


export function Divider() {
  return (
    <div className="my-3 h-[3px] w-[30px] mx-auto rounded-lg" style={{
      background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf)',
    }}/>
  );
}

export function Button({children,click,disabled, backgroundColor, textColor}) {
  return (
  !children && !disabled && !click ?
  <>
  [Button click=function_to_handle] your text [/Button]
  </> :
  <>
    <div style={{opacity:disabled ? "0.5" : "1",border: "solid 1px #303030",borderRadius:"10px",cursor:"pointer"}}
        onClick={click}
        >
            <div style={{
                borderRadius:"8px",
                borderTop: "1px solid #646464",
                borderLeft: "1px solid #646464",
                borderRight: "1px solid #646464",
                borderBottom:  "1px solid #0a0a0a",
                color: textColor ? textColor : "white",
                backgroundColor: backgroundColor ? backgroundColor : "#343434",
                padding:"2px 0",
                textAlign:"center",
                fontSize:"0.8rem"}}>
                {children}
            </div>
        </div>
  </>
  )
}

export function Badge({children,status}) {
    return (
    !children && !status ? <>
    [Badge status=success or null][/Badge]
    </> :
    <>
    <span style={{backgroundColor: status && status == 'success' ? "#b4fed2" : "#ffd6a5",display:"flex",width:"fit-content",padding:"2px 8px 2px 6px",borderRadius:"10px",margin:"auto"}}>
        { status && status == 'success' ?
        <svg style={{width:"15px"}} fill="#28845b" viewBox="0 0 20 20"><path d="M6 10c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.121-2.122C8.605 6 9.07 6 10 6c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C14 8.605 14 9.07 14 10s0 1.395-.102 1.777a3 3 0 0 1-2.122 2.12C11.395 14 10.93 14 10 14s-1.395 0-1.777-.102a3 3 0 0 1-2.12-2.121C6 11.395 6 10.93 6 10Z"></path></svg> :
        <svg style={{width:"15px"}} fill="#b38401" viewBox="0 0 20 20"><path fillRule="evenodd" d="m8.888 6.014-.017-.018-.02.02c-.253.013-.45.038-.628.086a3 3 0 0 0-2.12 2.122C6 8.605 6 9.07 6 10s0 1.395.102 1.777a3 3 0 0 0 2.121 2.12C8.605 14 9.07 14 10 14c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.121C14 11.395 14 10.93 14 10c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C11.395 6 10.93 6 10 6c-.475 0-.829 0-1.112.014ZM8.446 7.34a1.75 1.75 0 0 0-1.041.94l4.314 4.315c.443-.2.786-.576.941-1.042L8.446 7.34Zm4.304 2.536L10.124 7.25c.908.001 1.154.013 1.329.06a1.75 1.75 0 0 1 1.237 1.237c.047.175.059.42.06 1.329ZM8.547 12.69c.182.05.442.06 1.453.06h.106L7.25 9.894V10c0 1.01.01 1.27.06 1.453a1.75 1.75 0 0 0 1.237 1.237Z"></path></svg>
        }
        <p>{children}</p>
    </span>
    </>);
}
export function Spinner({ color = "#269af2", size = 24 }) {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderLeftColor: color,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "auto"
  };

  return (
    <div style={{ display: "inline-block", position: "relative" }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={spinnerStyle}></div>
    </div>
  );
}

export function Toast({ children, status }) {
  const [visible, setVisible] = useState(status);

  useEffect(() => {
    if (status) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [status]);

  const toastStyle = {
    position: "fixed",
    bottom: "10px",
    left: "0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    transform: visible ? "translateY(0)" : "translateY(100%)",
    opacity: visible ? "1" : "0",
    transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
    zIndex: "999999999999999999999999999"
  };

  return (
    <div style={toastStyle}>
      <div style={{ width: "fit-content", margin: "auto", display: "flex" }}>
        <div style={{ display: "block", textAlign: "center" }}>
          <Button>
            <span
              style={{
                padding: "0 10px",
                maxWidth: "200px", // 👈 Giới hạn độ rộng
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                display: "inline-block"
              }}
            >
              <i>{children}</i>
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export function Notification({ children, status }) {
  const [visible, setVisible] = useState(status);

  useEffect(() => {
    if (status) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [status]);

  const toastStyle = {
    position: "fixed",
    bottom: "10px",
    left: "0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    transform: visible ? "translateY(0)" : "translateY(100%)",
    opacity: visible ? "1" : "0",
    transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
    zIndex: "999999999999999999999999999"
  };

  return (
    <div style={toastStyle}>
      <div style={{ width: "fit-content", margin: "auto", display: "flex" }}>
        <div style={{ display: "block", textAlign: "center" }}>
          <div>
            <span
              style={{
                padding: "0 10px",
                maxWidth: "200px", // 👈 Giới hạn độ rộng
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                display: "inline-block"
              }}
            >
              <i>{children}</i>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Skeleton() {
	return (<>
	<div role="status" class="max-w-sm animate-pulse">
		<div class="h-2.5 bg-gray-300 rounded-full w-48 mb-4"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[360px] mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[330px] mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[300px] mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[360px]"></div>
		<span class="sr-only">Loading...</span>
	</div>
	</>);
}
export function Popup({status,children,backgroundColor}) {
  return (
    <>
        <div style={{position:"fixed",top:"0",left:"0",zIndex:"9999999",height:"100vh",width:"100vw",backgroundColor: backgroundColor ? backgroundColor : "rgb(0 0 0 / 91%)", display: status === true ? "flex" : "none",}}>
            <div style={{maxWidth:"100vw",width:"calc(100vw - 50px)",margin:"50px auto",alignSelf:"center"}}>
                {children}
            </div>
        </div>
    </>
    );
}
export function TypingText({ text }) {
  const [displayed, setDisplayed] = useState("");
  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed(text.slice(0, i + 1));
      i++;
      if (i >= text.length) clearInterval(interval);
    }, 30); // tốc độ gõ

    return () => clearInterval(interval);
  }, [text]);
  return <p style={{ whiteSpace: "pre-line" }}>{displayed}</p>;
}

export const SearchBar = ({
  backgroundColor = "#1e1e1e",
  borderColor = "#646464",
  borderBottomColor = "#0a0a0a",
  textColor = "#ccc",
  inputTextColor = "#fff",
  placeholder,
  click,
  value,
  onChange,
  loading = false, // 🔥 thêm
}) => {
  return (
    <div
      style={{
        borderTop: `1px solid ${borderColor}`,
        borderLeft: `1px solid ${borderColor}`,
        borderRight: `1px solid ${borderColor}`,
        borderBottom: `1px solid ${borderBottomColor}`,
        backgroundColor,
        borderRadius: "14px",
        padding: "6px 16px",
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: "100%",
        color: textColor,
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <input
        type="text"
        placeholder={placeholder ?? "Tra cứu từ vựng ( sắp ra mắt ) ..."}
        style={{
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
          flexGrow: 1,
          color: inputTextColor,
          fontSize: "14px",
        }}
        value={value}
        onChange={onChange}
        disabled={loading}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#2d2d2d",
          borderRadius: "6px",
          padding: "2px 6px",
          fontSize: "12px",
          color: "#aaa",
          marginLeft: "8px",
          cursor: loading ? "not-allowed" : "pointer",
        }}
        onClick={loading ? undefined : click}
      >
        {loading ? (
          <Spinner color={backgroundColor}/>
        ) : (
          <>
            <span
              style={{
                backgroundColor: "#3a3a3a",
                borderRadius: "4px",
                padding: "2px 4px",
                marginRight: "4px",
              }}
            >
              ⌘
            </span>
            <span>Go</span>
          </>
        )}
      </div>
    </div>
  );
};

export function Loading({ color = "#000" }) {
  const encodedColor = encodeURIComponent(color); // để tránh lỗi với màu có dấu #

  const style = {
    width: "60px",
    aspectRatio: "2",
    background: `
      no-repeat radial-gradient(circle closest-side, ${color} 90%, #0000) 0% 50%,
      no-repeat radial-gradient(circle closest-side, ${color} 90%, #0000) 50% 50%,
      no-repeat radial-gradient(circle closest-side, ${color} 90%, #0000) 100% 50%`,
    backgroundSize: "calc(100% / 3) 50%",
    animation: "l3 1s infinite linear",
  };

  return (
    <>
      <div style={style}></div>
      <style>
        {`
          @keyframes l3 {
            20% { background-position: 0% 0%, 50% 50%, 100% 50%; }
            40% { background-position: 0% 100%, 50% 0%, 100% 50%; }
            60% { background-position: 0% 50%, 50% 100%, 100% 0%; }
            80% { background-position: 0% 50%, 50% 50%, 100% 100%; }
          }
        `}
      </style>
    </>
  );
}